import { ApartmentOutlined } from '@material-ui/icons';
import React from 'react';
import Question from '../question/Question';
import {
  Box,
  Container,
  Card,
  CardContent,
  Grid,
  makeStyles,
  Typography,
} from '@material-ui/core';
import clsx from 'clsx';

const Radio = ({
  icon,
  label,
  width,
  height,
  index,
  name,
  selectedValue,
  handleChange,
  hovercolor,
}) => {
  const useStyles = makeStyles({
    card: {
      width: width || 150,
      height: height || 150,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      padding: '5px',
      marginLeft: '10px',
      marginRight: '10px',
      marginTop: '10px',
      marginBottom: '10px',

      '&:hover': {
        border:
          hovercolor == undefined
            ? '5px solid #1D85FE'
            : '5px solid ' + hovercolor,
        boxShadow: '0 9px 12px 0 rgba(0,0,0,.2)',
        transform: 'translateY(-2px)',
        padding: '0px',
      },
    },
    selectedCard: {
      border:
        hovercolor == undefined
          ? '5px solid #1D85FE'
          : '5px solid ' + hovercolor,
      boxShadow: '0 9px 12px 0 rgba(0,0,0,.2)',
      transform: 'translateY(-2px)',
      padding: '0px',
    },
  });
  const classes = useStyles();
  return (
    <>
      <input
        id={`radioQuestion-${index}`}
        type="radio"
        name={name}
        onChange={handleChange}
        style={{ display: 'none' }}
      />
      <label htmlFor={`radioQuestion-${index}`}>
        <Card
          className={clsx(
            classes.card,
            selectedValue != undefined && index === selectedValue
              ? classes.selectedCard
              : ''
          )}
          variant="outlined"
        >
          <CardContent>
            <div className="flex flex-col items-center text-center">
              <img width="80px" src={icon} />

              <Typography variant="body2">{label}</Typography>
            </div>
          </CardContent>
        </Card>
      </label>
    </>
  );
};

const RadioCard = ({ daten, cardcontent, handleNext, url, hovercolor }) => {
  let cardID =
    daten['chain'].length > 0
      ? daten['chain'][daten['chain'].length - 1].toString()
      : daten['chain'][0].toString();
  let step = daten['chain'].length;
  let selectedValue = undefined;
  try {
    selectedValue = daten['info'][cardID]['selection'];
  } catch (error) {
    //no catch
  }
  const handleChange = index => {
    cardID in daten['info'] ? 0 : (daten['info'][cardID] = {}); //Create Dict in Info if not exists
    daten['info'][cardID]['selection'] = index;
    handleNext(daten);
  };

  let renderObjekt = (
    <div className="flex flex-wrap justify-center">
      {cardcontent['radiocard'].map((i, index, elements) => {
        if (index % 2 == 0) {
          if (index + 1 < elements.length) {
            return (
              <div className="flex flex-col smx:flex-row" key={i + 'x'}>
                <Radio
                  key={i}
                  index={index}
                  name={'radio' + index}
                  selectedValue={selectedValue}
                  label={i}
                  handleChange={e => handleChange(index)}
                  icon={url + cardcontent['images'][index]}
                  width={cardcontent['radiocard'].length > 4 ? 150 : 150}
                  height={cardcontent['radiocard'].length > 4 ? 120 : 150}
                  hovercolor={hovercolor}
                />
                <Radio
                  key={index + 1}
                  index={index + 1}
                  name={'radio' + index + 1}
                  selectedValue={selectedValue}
                  label={elements[index + 1]}
                  handleChange={e => handleChange(index + 1)}
                  icon={url + cardcontent['images'][index + 1]}
                  width={cardcontent['radiocard'].length > 4 ? 150 : 150}
                  height={cardcontent['radiocard'].length > 4 ? 120 : 150}
                  hovercolor={hovercolor}
                />{' '}
              </div>
            );
          } else {
            return (
              <div key={i + 'x'}>
                <Radio
                  key={i}
                  index={index}
                  name={'radio' + index}
                  selectedValue={selectedValue}
                  label={i}
                  handleChange={e => handleChange(index)}
                  icon={url + cardcontent['images'][index]}
                  width={cardcontent['radiocard'].length > 4 ? 150 : 150}
                  height={cardcontent['radiocard'].length > 4 ? 120 : 150}
                  hovercolor={hovercolor}
                />
              </div>
            );
          }
        }
      })}
    </div>
  );

  return (
    <div className="h-full flex flex-col justify-between p-2" id="radiocard">
      <div className="text-center mt-20px">
        <Question questionNo={step} questionText={cardcontent['headline']} />
      </div>
      <div>
        <div className="mx-auto">{renderObjekt}</div>
      </div>

      <div className="h-40px"></div>
    </div>
  );
};

export default RadioCard;
